import { useTheme } from 'styled-components';
import { useMediaQuery } from '@mui/material';
export { useMediaQuery };
export const useIsLargerThanPhone = () => {
    const theme = useTheme();
    return useMediaQuery(`(${theme.forLargerThanPhone})`);
};
//# sourceMappingURL=use-media-query.js.map